import type { FeatureSupportValue } from "@src/utils/sparks/parseFeatureSupportStatus";

export const ANDROID_MIN_VERSION = "8.3";
export const IOS_MIN_VERSION = "19.6.4";

export type SupportState = {
  android: FeatureSupportValue;
  ios: FeatureSupportValue;
};

type HeroCopy = { title: string; subtitle?: string };

export const getHeroCopy = ({ android, ios }: SupportState): HeroCopy => {
  const statuses = [android.status, ios.status];

  if (statuses.every((status) => status === "unavailable")) {
    return {
      title: "Feature support is coming soon",
      subtitle: "We’re bringing this update to more devices soon.",
    };
  }

  if (statuses.includes("unavailable")) {
    return {
      title: "Feature support update",
      subtitle: "See which platforms are ready right now.",
    };
  }

  return { title: "Oops, your app version does not support this feature" };
};

export const getPlatformMessage = (support: FeatureSupportValue, minVersion: string): string => {
  if (support.status === "unavailable") {
    return "Sorry, this feature isn’t available on this platform yet. Coming soon.";
  }
  return `Available from version ${minVersion}`;
};

export const getSupportParam = (params: URLSearchParams, names: string[]): string | null => {
  for (const name of names) {
    const value = params.get(name);
    if (value !== null) return value;
  }
  return null;
};
